export default "__VITE_ASSET__D$bzc_Cy__"